import { createFileRoute } from '@tanstack/react-router';
import { PartnerTopic } from '../screens/company/topics/PartnerTopic';

export const Route = createFileRoute('/t/$tenant/settings/billing/partner')({
  component: PartnerTopic,
});
